document.addEventListener('DOMContentLoaded', () => {
  const menuToggle = document.querySelector('[data-mobile-menu-toggle]');
  const nav = document.querySelector('[data-main-nav]');
  const setMenu = (open) => {
    if (!menuToggle || !nav) return;
    nav.classList.toggle('is-open', open);
    menuToggle.setAttribute('aria-expanded', String(open));
    document.body.classList.toggle('menu-open', open);
  };
  menuToggle?.addEventListener('click', () => setMenu(!nav?.classList.contains('is-open')));
  nav?.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setMenu(false)));
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') setMenu(false); });

  const desktopMenu = window.matchMedia('(min-width: 1081px)');
  document.querySelectorAll('[data-mega-menu]').forEach((details) => {
    let closeTimer;
    const cancelClose = () => window.clearTimeout(closeTimer);
    const closeMenu = () => {
      if (!desktopMenu.matches) return;
      closeTimer = window.setTimeout(() => details.removeAttribute('open'), 180);
    };
    details.addEventListener('mouseenter', () => {
      if (!desktopMenu.matches) return;
      cancelClose();
      document.querySelectorAll('[data-mega-menu][open]').forEach((menu) => {
        if (menu !== details) menu.removeAttribute('open');
      });
      details.setAttribute('open', '');
    });
    details.addEventListener('mouseleave', closeMenu);
    details.addEventListener('focusin', cancelClose);
    details.addEventListener('focusout', (event) => {
      if (!details.contains(event.relatedTarget)) closeMenu();
    });
  });

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const main = gallery.querySelector('.product-gallery__image');
    const zoom = gallery.querySelector('[data-gallery-zoom]');
    const thumbs = Array.from(gallery.querySelectorAll('[data-product-thumb]'));
    const data = gallery.querySelector('[data-gallery-images]');
    let images = [];
    let index = 0;
    let renderToken = 0;
    try { images = data ? JSON.parse(data.textContent || '[]') : []; } catch (error) { images = []; }
    const imageCache = new Map();
    const preloadImage = (src) => {
      if (!src || imageCache.has(src)) return imageCache.get(src);
      const promise = new Promise((resolve) => {
        const image = new Image();
        image.onload = () => resolve(true);
        image.onerror = () => resolve(false);
        image.src = src;
      });
      imageCache.set(src, promise);
      return promise;
    };
    const showImage = (nextIndex) => {
      if (!main || !images.length) return;
      index = (nextIndex + images.length) % images.length;
      const nextImage = images[index];
      const currentToken = ++renderToken;
      const thumbImage = thumbs[index]?.querySelector('img');
      const immediateSrc = thumbImage?.currentSrc || thumbImage?.src || nextImage.preview || nextImage.src;
      thumbs.forEach((thumb, thumbIndex) => thumb.classList.toggle('is-active', thumbIndex === index));
      main.removeAttribute('srcset');
      main.removeAttribute('sizes');
      main.alt = nextImage.alt || main.alt;
      main.src = immediateSrc;
      if (zoom) zoom.href = nextImage.zoom || nextImage.src;
      main.classList.add('is-loading');
      preloadImage(nextImage.src).then((loaded) => {
        if (!loaded || currentToken !== renderToken) return;
        main.src = nextImage.src;
        main.classList.remove('is-loading');
      });
      preloadImage(images[(index + 1) % images.length]?.src);
      preloadImage(images[(index - 1 + images.length) % images.length]?.src);
    };
    thumbs.forEach((button, thumbIndex) => button.addEventListener('click', () => showImage(thumbIndex)));
    gallery.querySelector('[data-gallery-prev]')?.addEventListener('click', () => showImage(index - 1));
    gallery.querySelector('[data-gallery-next]')?.addEventListener('click', () => showImage(index + 1));
    images.slice(1, 5).forEach((image) => preloadImage(image.src));
  });

  document.querySelectorAll('[data-search-form]').forEach((form) => {
    form.addEventListener('submit', () => {
      const input = form.querySelector('input[name="q"]');
      if (!input) return;
      input.value = input.value.trim().replace(/plug[\s-]+in/gi, 'plug*').replace(/plugin/gi, 'plug*');
    });
  });

  document.querySelectorAll('[data-qty-minus], [data-qty-plus]').forEach((button) => {
    button.addEventListener('click', () => {
      const input = button.closest('.quantity')?.querySelector('input[name="quantity"]');
      if (!input) return;
      const current = Number(input.value || 1);
      input.value = button.hasAttribute('data-qty-plus') ? current + 1 : Math.max(1, current - 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  const filterToggle = document.querySelector('[data-filter-toggle]');
  const filterPanel = document.querySelector('[data-filter-panel]');
  filterToggle?.addEventListener('click', () => {
    const open = filterPanel?.classList.toggle('is-open') || false;
    filterToggle.setAttribute('aria-expanded', String(open));
  });
  document.querySelector('[data-sort-select]')?.addEventListener('change', (event) => event.currentTarget.form?.submit());
});

